<template>
  <div style="text-align:left" class="container font-custom">
    <div class="intern text-white">
      <h1>Interne Seite</h1>
      <ul>
        <li><a href="https://nextcloud.cannonball-official.de" target="_blank">Cloud</a></li>
      </ul>
    </div>
  </div>
</template>